import styled from "styled-components";

import { mobileOnly, mobileAndTablet } from "_/style/media";
import { numericFontStyles } from "_/style";

import * as JobsListingS from "_/components/jobs-listing/styled";
import { Button } from "_/components/button";

export const Actions = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-left: 16px;
  }
`;

export const Details = styled.div`
  display: flex;
  padding: 8px 0;
  width: 100%;
`;

export const Meta = styled.div`
  display: flex;
`;

export const Title = styled.span`
  font-size: 26px;
  color: inherit;
`;

export const TitleStatus = styled.span`
  color: ${(p) => p.theme.text.muted};
  padding-left: 0.5rem;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 2rem;
  background-color: ${(p) => p.theme.subheader.background};
  padding: 0 24px;
  border-bottom: 1px solid ${(p) => p.theme.subheader.border};
  ${mobileAndTablet`
    gap: 0.5rem;
    flex-direction: column;
    padding: 0 1rem;
  `}
`;

export const LeftSection = styled.div``;

export const RightSection = styled.div`
  display: flex;
  align-items: stretch;
  padding: 1rem 0;
  margin-left: auto;
  flex-direction: column;
  ${mobileAndTablet`
    margin-left: 0;
    padding: 0.5rem 0 0 0;
  `}
  .react-select__control {
    min-width: 220px;
  }
  ${mobileOnly`
    .react-select__control {
      width: 90vw;
    }
  `}
`;

export const RightSectionItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  font-size: 0.875rem;
  ${mobileAndTablet`
    justify-content: flex-start; 
    padding-bottom: 1rem;
  `}
  ${mobileOnly`
    flex-wrap: wrap;
    justify-content: center;
  `}
  .react-select__menu,
  .react-select__control {
    /* 
      Ensure that revision/optimization/attempt pickers show date/time
      values with the same width. 
    */
    ${numericFontStyles}
  }
`;

export const PickerOptionWrapper = styled.div`
  margin-left: -0.25rem;
  margin-right: -1rem;
`;

export const PrintOrRevisionNumberInSelect = styled(
  JobsListingS.RevisionOrJobNumber
)`
  font-size: 0.875rem;
  margin-right: 0.25rem;
`;

export const RevisionWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PickerLabel = styled.label`
  color: ${(p) => p.theme.text.muted};
  font-size: 0.875rem;
  padding-bottom: 0.125rem;
  margin-left: 0.3125rem;
  ${mobileAndTablet`
    display: none;
  `}
`;

export const DeleteModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  > * {
    margin-left: 8px;
  }
`;

export const TabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  width: 100%;
`;

export const AddToQueueButton = styled(Button).attrs({
  size: "small",
  kind: "primary",
})`
  padding: 6px 12px;
  font-size: 14.5px;
`;

/**
 * The Analyze tab and its subview caret, held together as one tab.
 *
 * `TabBar` spaces its children 24px apart, so the caret needs its own container
 * to read as part of the tab rather than as a fifth tab.
 */
export const AnalyzeTab = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 0.125rem;
`;

export const SubviewCaret = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: ${(p) => p.theme.text.muted};
  cursor: pointer;
  display: inline-flex;
  justify-content: center;

  /* Square enough to hit comfortably beside the tab label. */
  min-height: 1.5rem;
  min-width: 1.5rem;
  padding: 0;

  &:hover {
    color: ${(p) => p.theme.text.hover};
  }
`;

export const SubviewItem = styled.span`
  display: flex;
  flex-direction: column;
`;

export const SubviewHint = styled.small`
  color: ${(p) => p.theme.text.muted};
`;
